import React from 'react';
import { Reveal } from './Reveal';
const includes = ["Modèles d'architecture de suivi", 'Plans hebdomadaires complets prêts à utiliser', 'Progression des compétences par niveau', 'Bibliothèques de consignes cliniques', 'Formulaires de suivi des patients', "Banques d'activités d'échauffement et de pratique", 'Protocoles de préparation de séance', 'Cadre de culture de cabinet professionnel'];
export function ModuleIncludes() {
  return <section className="w-full bg-black px-4 py-16" data-id="element-135">
      <div className="mx-auto max-w-4xl" data-id="element-136">
        <Reveal data-id="element-137">
          <h2 className="text-center font-display text-2xl uppercase leading-tight text-white sm:text-3xl" data-id="element-138">
            Ce qu'inclut chaque module :
          </h2>
        </Reveal>
        <Reveal delay={0.08} data-id="element-139">
          <ul className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-140">
            {includes.map(item => <li key={item} className="flex items-start gap-3 text-white/80" data-id="element-141">
                <span className="mt-0.5 text-base" data-id="element-142">✅</span>
                <span className="text-sm leading-relaxed sm:text-base" data-id="element-143">
                  {item}
                </span>
              </li>)}
          </ul>
        </Reveal>
      </div>
    </section>;
}